import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import BaseViewModel from "../../base/BaseViewModel";
import actions, { useActions } from "../../redux/actions";
import ErrorHandler from "../../base/ErrorHandler";
import { useSharePreview } from "../../helpers/generalHelper";

function useCompare() {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const { addToast } = useToasts();

  const { og: { description } = {}, logo: { fileUrl } = {} } = useSelector(
    (state) => state.storeConfig
  );
  const { metaTitle, metaTags } = useSharePreview(
    t("compare.compare"),
    description,
    fileUrl
  );

  const CompareActions = useActions(actions.CompareActions);
  const { currencyRate, currencySymbol } = useSelector(
    (state) => state.currencyData
  );
  const compareData = useSelector((state) => state.compareData);

  const [compareItems, setCompareItems] = useState([]);
  const [additionalInfo, setAdditionalInfo] = useState([]);

  const deleteFromCompare = (item) => {
    CompareActions.deleteFromCompare(item, compareItems)
      .then(() => {
        addToast(t("compare.removed"), {
          appearance: "error",
          autoDismiss: true,
        });
      })
      .catch(ErrorHandler);
  };

  useEffect(() => {
    setCompareItems(compareData);
    const numOfColumn = 3;
    const columns = [];
    for (let i = 0; i < numOfColumn; i += 1) {
      columns[i] = compareData.reduce((row, { pages }) => {
        if (pages[i]) {
          row.push(pages[i]);
        } else {
          row.push({ label: {}, content: {} });
        }
        return row;
      }, []);
    }
    setAdditionalInfo(columns);
  }, [compareData]);

  return {
    pathname,
    compareItems,
    currencySymbol,
    currencyRate,
    deleteFromCompare,
    additionalInfo,
    metaTitle,
    metaTags,
  };
}

const CompareViewModel = BaseViewModel(useCompare);

export default CompareViewModel;
